import type { StatusIconName } from '../../components/ui/StatusIcon';
import type { AbsorbReason, ChargeType } from '../../api/types';

/** Longest note the API accepts (#293 Contract). */
export const ABSORB_NOTE_MAX = 200;

/** The one code → label mapping for the Absorb dialog and the absorbed line (mirrors R15's reason picker). */
export const ABSORB_REASONS: readonly {
  code: AbsorbReason;
  label: string;
  hint: string;
  icon: StatusIconName;
}[] = [
  { code: 'DNM_GOODWILL', label: 'Goodwill', hint: 'DNM pays it as goodwill', icon: 'check' },
  {
    code: 'SHIPPER_REFUSED',
    label: 'Shipper refused',
    hint: 'Shipper won’t pay this charge',
    icon: 'close',
  },
  { code: 'OUR_MISTAKE', label: 'Our mistake', hint: 'Too late to bill the shipper', icon: 'undo' },
  { code: 'OTHER', label: 'Other', hint: 'Add a short note', icon: 'edit' },
];

/** Unknown or newer codes still read as a reason, never as a raw code. */
export function absorbReasonLabel(code: string): string {
  return ABSORB_REASONS.find((r) => r.code === code)?.label ?? 'Other reason';
}

/** A reason is picked, the note fits, and Other carries a note. */
export function absorbReasonValid(code: AbsorbReason | null, note: string): boolean {
  if (!code) return false;
  const trimmed = note.trim();
  if (trimmed.length > ABSORB_NOTE_MAX) return false;
  return code !== 'OTHER' || trimmed.length > 0;
}

const CHARGE_TYPE_LABELS: Record<ChargeType, string> = {
  HALTING: 'Halting',
  LOADING: 'Loading',
  UNLOADING: 'Unloading',
  OTHER: 'Other charge',
};

export function chargeTypeLabel(type: string): string {
  return CHARGE_TYPE_LABELS[type as ChargeType] ?? 'Other charge';
}
